import { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';
import { FiltersDropdown } from '@shared/components/ui/FiltersDropdown';
import { Search } from '@shared/components/ui/Search';
import { ColumnSelector } from '@shared/components/ui/ColumnSelector';
import { ColumnDef } from '@tanstack/react-table';
import { ChangeEvent, useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ShipmentsFilters } from '../../adapters/ShipmentsApiAdapter';
import { InvoicesOrdersFiltersPanel } from './InvoicesOrdersFiltersPanel';
import { DownloadExcelButton } from './DownloadExcelButton';

interface FiltersSectionProps {
  handleSearch: (value: string) => void;
  onFilterChange?: (conditions: FilterConditionOutput[]) => void;
  columns: ColumnDef<any>[];
  selectedColumns: string[];
  onColumnsChange: (newSelected: string[]) => void;
  filterConditions: FilterConditionOutput[];
  hasTeamData?: boolean;
  searchTerm: string;
  exportFilters?: ShipmentsFilters;
}

export const FiltersSection = ({
  handleSearch,
  onFilterChange,
  columns,
  selectedColumns,
  onColumnsChange,
  filterConditions,
  searchTerm,
  exportFilters,
}: FiltersSectionProps) => {
  const { t } = useTranslation('invoicesOrdersModule');
  const [inputValue, setInputValue] = useState(searchTerm);

  useEffect(() => {
    setInputValue((prev) => (prev === searchTerm ? prev : searchTerm));
  }, [searchTerm]);

  const handleFilterChange = useCallback(
    (conditions: FilterConditionOutput[]) => {
      onFilterChange?.(conditions);
    },
    [onFilterChange],
  );

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleSearchSubmit = () => {
    handleSearch(inputValue.trim());
  };

  const activeFiltersCount = filterConditions.length;

  return (
    <>
      <Search
        placeholder={t('search.placeholder')}
        value={inputValue}
        onChange={handleInputChange}
        onEnter={handleSearchSubmit}
        dataTestId="search"
        inputDataTestId="search-input"
      />
      <FiltersDropdown
        title={t('filters.filters', 'Filtros')}
        triggerLabel={t('filters.filters', 'Filtros')}
        activeFiltersCount={activeFiltersCount}
        triggerTestId="invoices-orders-filters-toggle"
      >
        <InvoicesOrdersFiltersPanel initialConditions={filterConditions} onChange={handleFilterChange} />
      </FiltersDropdown>
      <ColumnSelector
        columns={columns}
        selected={selectedColumns}
        onColumnsChange={onColumnsChange}
        storageKey="invoices-orders-ag-grid-table"
      />
      {exportFilters && <DownloadExcelButton filters={exportFilters} selectedColumns={selectedColumns} />}
    </>
  );
};
